import React, { useEffect, useState }  from 'react';
import { Box } from '@material-ui/core';
import {SignaDrawer} from './../drawer/SignaDrawer';
import {Copyright} from './Copyright';
import { useDataProvider } from '../../api/DataProvider';
import { pDB_user_roles } from '../../utils/parameters';
import "../../styles/devices/mob_HomeWrapper.css";

export function HomeWrapper({ children }) {
    const { currentUserRole } = useDataProvider();
    const [showDrawer, setShowDrawer] = useState(false);

    // MOB - Make content adapt when user role is updated and drawer becomes visible
    useEffect(() => {
        if (currentUserRole !== pDB_user_roles.none){
            setShowDrawer(true);
        }
    },[currentUserRole]);

    return (
        <div className="sig_Home_Root">
            <SignaDrawer />
            <main className={`sig_Home_Content ${showDrawer ? 'sig_Home_ContentVisibleDrawer' : 'sig_Home_ContentHiddenDrawer'}`}>
                <div className="sig_Home_ToolbarSpace" />
                {children}
                <br className='sig_Home_RemovableElement' />
                <Box className='sig_Home_Copyright'>
                    <Copyright />
                </Box>
            </main>
        </div>
    )
}